import { render, staticRenderFns } from "./RepeatingContent.vue?vue&type=template&id=b55c91e6&scoped=true&"
import script from "./RepeatingContent.vue?vue&type=script&lang=js&"
export * from "./RepeatingContent.vue?vue&type=script&lang=js&"
import style0 from "./RepeatingContent.vue?vue&type=style&index=0&id=b55c91e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55c91e6",
  null
  
)

export default component.exports